module.exports = __webpack_public_path__ + "img/view_all.c48355bd.svg";